"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgAnonims = function SvgAnonims(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 23"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#17181A",
    d: "M10.207 1.136c.808-.06 1.316-.098 1.524-.112 1.149-.087 2.024.566 2.628 1.958.904 2.089 2.273 7.966.396 16.076-.297 1.902-1.459 2.746-2.527 2.618a88.727 88.727 0 0 0-2.068-.226c-.834-.163-1.175-.763-1.023-1.8.227-1.555.176-1.037.386-2.284.21-1.247.32-1.13 1.68-1.739 1.36-.61 1.717-.282 1.728-2.177.007-1.264-.037-2.934-.132-5.01.01-.736-.441-1.172-1.355-1.31-1.37-.205-1.682-.507-2.013-1.944a23.43 23.43 0 0 1-.474-2.756c.026-.803.442-1.234 1.25-1.294z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.621.672.707.707-4.95 4.95-.706-.708zm0 19.656.707-.707-4.95-4.95-.706.708zM19 10h6v1h-6zM1.379.672l-.707.707 4.95 4.95.706-.708zm0 19.656-.707-.707 4.95-4.95.706.708zM6 10H0v1h6z",
    fill: "#17181A"
  })));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgAnonims);
var _default = exports["default"] = Memo;